import { TDynamicStoreField } from '../../../store/store';
import { TUserRegistrationData } from '../../../types/types';
import { COOKIE_NAMES } from '../../../utils/constants';
import { getCookieByName } from '../../../utils/cookies';
import { separateBirthdate } from '../../../utils/utils';

export const adaptEnGbRegistrationUserData = (
  registrationData: TDynamicStoreField | null,
  marketCode: string,
) => {
  if (registrationData) {
    const birthdate = separateBirthdate(registrationData.dateOfBirth);

    const result: TUserRegistrationData = {
      ...registrationData,
      ...birthdate,
      trackingId: getCookieByName(COOKIE_NAMES.KAZUMO_TRACKING_ID),
      marketCode,
      address:    {
        ...registrationData.address,
        isVerified: registrationData.address?.isVerified || true,
      },
      phoneVerified:    false,
      marketingConsent: {
        casino: {
          contactBySms:   registrationData?.marketingConsent?.casino?.contactBySms || false,
          contactByEmail: registrationData?.marketingConsent?.casino?.contactByEmail || false,
          contactByPhone: registrationData?.marketingConsent?.casino?.contactByPhone || false,
          contactByPost:  registrationData?.marketingConsent?.casino?.contactByPost || false,
          contactByPushNotification:
            registrationData?.marketingConsent?.casino?.contactByPushNotification || false,
        },
        sports: {
          contactBySms:   registrationData?.marketingConsent?.sports?.contactBySms || false,
          contactByEmail: registrationData?.marketingConsent?.sports?.contactByEmail || false,
          contactByPhone: registrationData?.marketingConsent?.sports?.contactByPhone || false,
          contactByPost:  registrationData?.marketingConsent?.sports?.contactByPost || false,
          contactByPushNotification:
            registrationData.sports?.contactByPushNotification || false,
        },
      },
    };

    return result;
  }

  return null;
};
